import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "@p81-common/shell-core-js/dist/redux/addressesGet";
import { decode } from "@p81-common/shell-core-js";
import { DEFAULT_QUERY } from "@p81-common/shell-core-js";

export function request(params) {
  return requestWithSubTenantIfNeeded("get", "addresses", {
    searchParams: {
      ...params,
      ...(params.q
        ? {
            q: JSON.stringify({
              "attributes.name": params.q,
              "attributes.description": params.q,
              "attributes.value": params.q,
            }),
            qType: "partial",
          }
        : {}),
    },
  });
}

function* addressesGet(action) {
  let params = {
    ...DEFAULT_QUERY,
    ...(action.params || decode()(window.location.search)),
  };
  try {
    let { data } = yield call(request, params);
    const { addresses, relationships } = data;

    const collectionsByObjectId = relationships.references.reduce(
      (acc, { sharedObjectId, referenceCollection }) => {
        if (sharedObjectId) (acc[sharedObjectId] ??= []).push(referenceCollection);
        return acc;
      },
      {}
    );

    const addressesWithReferences = {
      ...addresses,
      data: addresses.data.map((address) => ({
        ...address,
        references: collectionsByObjectId[address.id] ?? [],
      })),
    };

    yield put(actions.requestSuccess(addressesWithReferences, params));
  } catch (error) {
    yield put(actions.requestFailure(error, params));
  }
}

function* saga() {
  yield takeEvery(actions.ADDRESSES_GET_REQUEST, addressesGet);
}

export default saga;
